package br.com.texeratx.boardgametimeapp.core.i18n

import br.com.texeratx.boardgametimeapp.core.storage.LanguageStorage
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn

class LanguageManager(private val storage: LanguageStorage) {

    private val scope = CoroutineScope(Dispatchers.Default)

    private val _language = MutableStateFlow(AppLanguage.PT)
    val language: StateFlow<AppLanguage> = _language.asStateFlow()

    val strings: StateFlow<Strings> = _language.map { lang ->
        when (lang) {
            AppLanguage.PT -> PtStrings
            AppLanguage.EN -> EnStrings
        }
    }.stateIn(scope, SharingStarted.Eagerly, PtStrings)

    suspend fun init() {
        val saved = storage.getLanguage()
        if (saved != null) {
            _language.value = saved
        }
    }

    suspend fun setLanguage(lang: AppLanguage) {
        storage.saveLanguage(lang)
        _language.value = lang
    }
}
